const CMSObjectsActionsServices = (instance) => {

    const getActions = () => instance.get('object-actions/');

    return {
        getActions
    };
};
export default CMSObjectsActionsServices;